import { userDashboard } from "./user-dashboard.route";

export const dashboardList = [userDashboard];
